import React, { Component } from "react";
import Button from "../../Button/Button";
import "./ResultsNav.css";

class ResultsNav extends Component {
	componentWillMount() {
		this.query = this.props.getQuery();
	}
	render() {
		// search results type label for results nav
		let searchTypeLabel = this.props.query.type.slice(0, -1);
		// number of search results
		let searchResultsNum;
		// set number of search results if any are available
		if (this.props.searchResults) {
			searchResultsNum = this.props.searchResults.length;
		} else {
			searchResultsNum = 0;
		}
		
		
		return (
			<div className="results-nav">
				<h2>
					{searchTypeLabel} SEARCH: {searchResultsNum} RESULTS
				</h2>
				<p className="results-query">{`BUSINESS: ${this.query.business ===
				undefined
					? "All"
					: this.query.business} || REGION: ${this.query.region === undefined
					? "Global"
					: this.query.region} || NEIGHBOR: ${this.query.neighbor === undefined
					? "All"
					: this.query.neighbor}`}</p>
				<div className="results-actions">
					<Button label="Redo Search" onClick={() => this.props.toggleLeftSearchPanel()}/>
					<a
						href={`data:text/csv,${encodeURI(this.props.dataToExport)}`}
						download="fmeasure_results.csv"
					>
						<Button label="Export" />
					</a>
				</div>
			</div>
		);
	}
}

export default ResultsNav;


// WEBPACK FOOTER //
// ./src/components/SearchResults/ResultsNav/ResultsNav.js